import { Action as ReduxAction } from 'redux'
import { DetailViewAction } from '../constants'

/* Action definitions */

export interface ISetDetailVisibility extends ReduxAction {
  // tslint:disable-next-line:no-reserved-keywords
  type: DetailViewAction.SET_DETAIL_VISIBILITY
  isVisible: boolean
}

/* Action creators */

export const setDetailVisibility = (isVisible: boolean): ISetDetailVisibility => ({
  type: DetailViewAction.SET_DETAIL_VISIBILITY,
  isVisible: isVisible,
})

export type SetDetailVisibilityAction = ISetDetailVisibility
